import axios from 'axios';
import { getAuthHeaders } from '../Auth';

export const uploadJsonDocumentAndGetDocumentUrl = async (
    jsonDocument: any,
    signal?: AbortSignal,
    deleteAfterDays?: number,
): Promise<string> => {
    const storageApi = 'https://storage.documents.cimpress.io/v3/documents';

    try {
        const headers = await getAuthHeaders();
        jsonDocument.deleteAfterDays = deleteAfterDays;
        const result = await axios.post(storageApi, jsonDocument, {
            headers,
            signal,
        });
        const documentUrl = result.data._links.self.href;
        return documentUrl;
    } catch (error) {
        if (signal?.aborted) {
            throw error;
        }

        console.error(`An error occurred while uploading document: ${error}`);
        throw error;
    }
};
